import React, { Component, PropTypes } from 'react';

import './AutocompleteCheckboxOption.scss';

export default class AutocompleteCheckboxOption extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    unavailable: PropTypes.bool,
    children: PropTypes.node,
    focused: PropTypes.bool,
  };

  render() {
    const { checked, focused, unavailable, children } = this.props;

    return (
      <div className={`autocomplete-checkbox-option ${checked ? 'autocomplete-checkbox-option--checked' : ''} ${unavailable ? 'autocomplete-checkbox-option--unavailable' : ''} ${focused ? 'autocomplete-checkbox-option--focused' : ''}`}>
        <input className="autocomplete-checkbox-option__checkbox" type="checkbox" checked={checked} readOnly disabled={unavailable} />
        { children }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Autocomplete/AutocompleteCheckboxOption.jsx
 **/